import React from "react";
import { motion } from "framer-motion";
import { Reveal, Label } from "./anim";
import { EXPERIENCE } from "../data/content";

export const Experience = () => {
  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="relative bg-[#EFEBDE] py-24 md:py-40"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <Label>Experience</Label>
          <h2 className="mt-6 font-display font-semibold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] max-w-3xl text-[#16281C]">
            A decade across the counter.
          </h2>
        </Reveal>

        <div className="mt-16 md:mt-24">
          {EXPERIENCE.map((job) => (
            <motion.div
              key={job.company}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className="group grid lg:grid-cols-[0.9fr_1.1fr] gap-6 lg:gap-16 py-10 md:py-14 border-t border-[#16281C]/12 last:border-b"
            >
              <div>
                <span className="font-mono text-xs tracking-[0.2em] uppercase text-[#2C5F3A]">
                  {job.dates}
                </span>
                <h3 className="mt-4 font-display font-semibold text-3xl md:text-4xl tracking-tight text-[#16281C] group-hover:translate-x-1 transition-transform duration-500">
                  {job.company}
                </h3>
                <p className="mt-2 font-body text-base text-[#4C5C50]">{job.role}</p>
                <p className="mt-1 font-mono text-[11px] tracking-[0.15em] uppercase text-[#8B978C]">
                  {job.location}
                </p>
              </div>
              <ul className="space-y-4">
                {job.points.map((p, j) => (
                  <li key={j} className="flex gap-4 font-body text-base md:text-[17px] text-[#4C5C50] leading-relaxed">
                    <span className="mt-2.5 shrink-0 w-2 h-2 bg-[#2C5F3A]" />
                    {p}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
